{
  "colorInputLabel": "{label}, {channelLabel}",
  "colorNameAndValue": "{name} : {value}",
  "colorPicker": "Sélecteur de couleurs",
  "twoDimensionalSlider": "Curseur 2D",
  "colorSwatch": "color swatch",
  "transparent": "transparent"
}
